import { render, staticRenderFns, recyclableRender, components } from "./recommendProduct.vue?vue&type=template&id=7d1f3964&"
var renderjs
import script from "./recommendProduct.vue?vue&type=script&lang=js&"
export * from "./recommendProduct.vue?vue&type=script&lang=js&"
import style0 from "./recommendProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/recommendProduct/recommendProduct.vue"
export default component.exports